import { ITrainingCourseResponse } from '@/types/views/trainingCourse.types';
import { GridPaginationModel, GridSortModel } from '@mui/x-data-grid-pro';
import { isNil } from 'lodash';
import { queryKeys } from './queryKeys';
import { useAppQuery } from './useAppQuery';

interface Props {
  searchText?: string;
  paginationModel?: GridPaginationModel;
  sortModel?: GridSortModel;
  providerIds?: string[];
  regionNames?: string[];
  facultyIds?: string[];
  languageCodes?: string[];
  courseTypes?: string[];
  priceMin?: number;
  priceMax?: number;
  hasEnrolments?: boolean;
}

export const useGetTrainingCourses = ({
  searchText,
  paginationModel,
  sortModel,
  providerIds,
  regionNames,
  facultyIds,
  languageCodes,
  courseTypes,
  priceMin,
  priceMax,
  hasEnrolments,
}: Props) => {
  const params = {
    searchText: searchText || undefined,
    pageNumber: (paginationModel?.page || 0) + 1,
    pageSize: paginationModel?.pageSize || undefined,
    orderBy: `${sortModel?.[0]?.field} ${sortModel?.[0]?.sort}`,
    providerIds: providerIds?.length ? providerIds : undefined,
    regionNames: regionNames?.length ? regionNames : undefined,
    facultyIds: facultyIds?.length ? facultyIds : undefined,
    languageCodes: languageCodes?.length ? languageCodes : undefined,
    courseTypes: courseTypes?.length ? courseTypes : undefined,
    minPriceInCents: !isNil(priceMin) ? String(priceMin) : undefined,
    maxPriceInCents: !isNil(priceMax) ? String(priceMax) : undefined,
    hasEnrolments: hasEnrolments ? 'true' : undefined,
  };

  return useAppQuery<ITrainingCourseResponse>('/TrainingManager/courses', {
    config: {
      params,
      paramsSerializer: { indexes: null },
    },
    placeholderData: undefined,
    queryKey: queryKeys.trainingCourses.list(params),
  });
};
